const resumo_de_vagas = [
  {
    path: "/resumo-de-vagas",
    redirect: "/resumo-de-vagas",
    meta: {
      breadCrumb: "Gestão - Apoio Gerencial Gestão de Classe",
    },
    children: [
      {
        path: "/resumo-de-vagas",
        name: "resumo-de-vagas",
        component: () => import("@/views/ResumoDeVagas/ResumoDeVagas.vue"),
      },
    ],
  },
];

export { resumo_de_vagas };
